// libraries.
import { Form } from 'react-bootstrap';
import { robotoRegular } from '@habitech/shared';
import { useDispatch, useSelector } from 'react-redux';

// slices.
import {
  setBusinessLine,
  getSelectedBusinessLine,
  BusinessLine,
} from '../store/slices/georeferencing-slice';

export const BusinessLineDropdown = () => {
  const dispatch = useDispatch();
  const selectedBusinessLine = useSelector(getSelectedBusinessLine);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value as BusinessLine;
    dispatch(setBusinessLine(value || null));
  };

  return (
    <div className="d-flex flex-column gap-2">
      <Form.Select
        aria-label="Seleccionar línea de negocio"
        value={selectedBusinessLine || ''}
        onChange={handleChange}
        style={{ fontFamily: robotoRegular, fontSize: '14px' }}
      >
        <option value="">Línea de negocio</option>
        <option value="Inmo">Inmo</option>
        <option value="Market-Maker">Market-Maker</option>
      </Form.Select>
    </div>
  );
};
